import httpRequest from "@/services/httpRequest"

export default ({
  namespaced: true,
  state: {
    listData: null,
    itemData: null,
  },
  mutations: {
    SET_LIST_DATA_LAPORIN(state, data) {
      state.listData = data
    },
    SET_ITEM_LAPORIN(state, data) {
      state.itemData = data
    },
  },
  actions: {
    async getListDataLaporin({ rootState, state, commit }, { param, page = 1, pageSize = 10, isLoadMore = false }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/laporin`,
          method: 'GET',
          params: {
            ...param,
            page: page,
            rows: pageSize,
          },
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        const results = res.data.results || []

        if (isLoadMore) {
          const newList = [...state.listData, ...results]
          await commit('SET_LIST_DATA_LAPORIN', newList)
        } else {
          await commit('SET_LIST_DATA_LAPORIN', results)
        }
        return { results, status: 'success' };
      } else {
        return { results: [], status: 'error' };
      }
    },
    async getItemLaporin({ rootState, commit }, idLaporin) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/laporin/${idLaporin}`,
          method: 'GET',
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        commit('SET_ITEM_LAPORIN', res.data)
      }
    },
    async createLaporin({ rootState, dispatch }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/laporin`,
          method: 'POST',
          data: data
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200 || res.status === 201) {
        await dispatch('getListDataLaporin', { param: {} })
        return true
      }
    },
    async actionLaporin({ rootState, dispatch }, { id, data }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/laporin/${id}/do`,
          method: 'POST',
          data: data
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        await dispatch('getListDataLaporin', { param: {} })
        return true
      }
    },
    async updateDataLaporin({ rootState, dispatch }, { id, data }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/sos/${id}`,
          method: 'PATCH',
          data: data
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        await dispatch('getListDataLaporin', { param: {} })
        return true
      }
    },
  }
})
